import type OrganizationWorkflowView from '@UI/Store/OrganizationWorkflows/Views/OrganizationWorkflowView';

/** "1. A + B → 2. C": the documents of each stage, joined by `+` within a stage and `→` between stages. */
const describeStages = (workflow: OrganizationWorkflowView): string =>
	workflow.stages
		.map((stage) => `${stage.stageNumber}. ${stage.steps.map((step) => step.label).join(' + ')}`)
		.join(' → ');

export default describeStages;
